import React, { Component } from 'react'

import Avatar from '../../../SPRINTA/atoms/Avatar'


import style from './style.css'

export default class NotificationItem extends Component {
    render() {
        return (
            <div className={style.box} style={{...this.props.style}}>
                <a href={this.props.link}>
                    <div className={style.avatar}>
                        <Avatar size={40} img={this.props.avatar} />
                    </div>
                    <div className={style.text}>
                        <span dangerouslySetInnerHTML={{ __html: this.props.html }} />
                    </div>
                </a>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/NotificationItem/index.js